//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
const Action = class Action {
  //TODO SACHA THIS NEEDS TO BE BASE ACTION AND EVERYTHING EXTEND FROM IT LIKE IN SERVER
  constructor(page, type, event) {
    this.page = page;
    this.type = type;
    this.event = event;
    this.transitionType = "fadein";
    this.sound = null;
    this.mixpanelEvent = null;
    this.successMixpanelEvent = null;
    this.id = "WEBAPP_INNER_PAGE";
    if (this.page) {
      this.analyticsEvent = {
        eventName: page.title,
        description: page.message,
      };
    }
  }
};

export default Action;
